<app-dialog [show]="show" [size]="size" [position]="position" [showHeader]="false" (close)="onClose()">
  <div class="flex flex-col h-full justify-between px-4 py-5">
    <!-- Centered Content -->
    <div class="flex flex-1 flex-col items-center justify-center text-center">
      <ng-container *ngIf="!isError; else errorBlock">
        <i class="pi pi-check-circle text-green-500 text-6xl mb-6"></i>
        <div class="text-2xl font-semibold mb-2">Transaction Created</div>
        <div class="text-base text-gray-700">
          <ng-container *ngIf="agency; else noAgency">
            The transaction for file number <span class="font-bold">{{ fileNumber }}</span><br>
            within agency <span class="font-bold">{{ agency }}</span> has been created and sent.
          </ng-container>
          <ng-template #noAgency>
            The transaction for file number <span class="font-bold">{{ fileNumber }}</span><br>
            has been created and sent.
          </ng-template>
        </div>
      </ng-container>
      <ng-template #errorBlock>
        <i class="pi pi-times-circle text-red-600 text-6xl mb-6"></i>
        <div class="text-2xl font-semibold mb-2 text-red-600">An error occurred</div>
        <div class="text-base text-gray-700 mb-2">
          Something went wrong while processing your request to {{action}}. Please try again later.
        </div>
      </ng-template>
    </div>

    <div *ngIf="!isError" class="flex justify-end">
      <div class="text-sm text-gray-500 mb-1 mr-1 text-center">
        Reminder: Let the recipient know they’ll soon receive an email/text from WFG National Title/Proof.
      </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-end mt-6 gap-2">
      <button *ngIf="isError && showBack" type="button" (click)="onBack()"
        class="h-10 w-24 rounded-lg bg-gray-200 text-gray-800 hover:bg-gray-300 text-base transition-colors cursor-pointer">
        Back
      </button>
      <button type="button" (click)="onClose()"
        class="h-10 w-24 rounded-lg bg-black text-white hover:bg-gray-800 text-base transition-colors cursor-pointer">
        OK
      </button>
    </div>
  </div>
</app-dialog>